'use client'

import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { Text, Spacer } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { formatCurrencyAmount } from '@marketplace-web/currency/currency-data'

import { UserBalanceContext } from '../../../containers/UserBalanceProvider'

type Props = {
  currentUserId?: number
  isItemOwner?: boolean
}

const BalanceDisplay = ({ currentUserId, isItemOwner }: Props) => {
  const { locale } = useIntl()
  const { userBalance } = useContext(UserBalanceContext)
  const translate = useTranslate('item.balance_display')
  const isKillSwitchEnabled = useFeatureSwitch('killswitch_wallet_balance_load_in_item_page')
  const isBalanceDisplayHidden = useFeatureSwitch('hide_wallet_balance_in_item_page')
  const isBalanceDisplayHiddenInWeb = useFeatureSwitch('hide_wallet_balance_in_item_page_web')

  const hasBalance = userBalance && Number(userBalance.availableAmount) > 0
  const isHidden =
    isKillSwitchEnabled ||
    isBalanceDisplayHidden ||
    !currentUserId ||
    !hasBalance ||
    isItemOwner ||
    isBalanceDisplayHiddenInWeb

  if (isHidden) return null

  return (
    <>
      <Spacer size={Spacer.Size.Small} />
      <Text
        as="div"
        type={Text.Type.Subtitle}
        text={translate('item_user_available_wallet_balance', {
          amount: formatCurrencyAmount(
            {
              currencyCode: userBalance.currency,
              amount: userBalance.availableAmount,
            },
            locale,
          ),
        })}
      />
    </>
  )
}

export default BalanceDisplay
